import React from 'react';
import { FormComponent } from '../../../../components/form/DynamicForm'
import { Form, Validators } from '../../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../../Http';
import { objectAsParams } from '../../../../helpers';
import moment from 'moment';

class PagoTransportista extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'contra-recibo/one', saveUrl: 'contra-recibo/save', backUrl: 'jfhdfs' },
      new Form([
        Form.Field('date', 'inicio', 'Inicio', false, [Validators.required], 6),
        Form.Field('date', 'fin', 'Fin', false, [Validators.required], 6),
        Form.Field('select', 'id_sucursal', 'Sucursal', '', [Validators.required], 12),
      ], ['Reporte Excel', 'Descargar PDF'], 'Pago a transportistas por recolecciones'), this.formData
    )

    // this.LoadPreds(this.props.factura.id, false);
  }

  formData = async (form) => {
    let newForm = form;
    let Res = await Http.get('reporte-cobranza/reporte/form');
    console.log(Res);
    if (!Res.error) {
      newForm = Form.FieldOptions(form, 'id_sucursal', [{ id: 0, sucursal_nombre: 'Todas' }, ...Res.data.sucursales], 'id', 'sucursal_nombre');
      // newForm = Form.FieldOptions(form, 'id_ejecutivo', [{ id: 0, ejecutivo_nombre: 'Cualquiera' }, ...Res.data.ejecutivos], 'id', 'ejecutivo_nombre');
      // newForm = Form.FieldOptions(form, 'id_cliente', [{ id: 0, cliente_rsocial: 'Cualquiera' }, ...Res.data.clientes], 'id', 'cliente_rsocial');
    }
    return newForm;
  }

  onSubmit = async (button, vals) => {
    // console.log(vals);
    this.setState({ loading: true });
    const inicio = moment(vals.inicio).format('YYYY-MM-DD');
    const fin = moment(vals.fin).format('YYYY-MM-DD');
    let params = {
      ...vals,
      inicio,
      fin,
    }
    try {
      if (button === 2) {
        let Res = await Http.get(`transportista/pago-reporte-pdf?${objectAsParams(params)}`, true, 'arraybuffer');
        let response = null;
        try {
          let decodedString = String.fromCharCode.apply(null, new Uint8Array(Res));
          response = JSON.parse(decodedString);
        } catch (error) {
          console.log(error);
        }
        if (response && response.error) {
          this.setState({ sbOpen: true, sbMsg: 'Ocurrió un error al generar el PDF' });
        } else {
          const blob = new Blob([Res], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `pago_recolecciones_${inicio}-${fin}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      } else {
        let Res = await Http.get(`transportista/pago-reporte?${objectAsParams(params)}`, true, 'arraybuffer');
        let response = null;
        try {
          let decodedString = String.fromCharCode.apply(null, new Uint8Array(Res));
          response = JSON.parse(decodedString);
        } catch (error) {
          console.log(error);
        }
        if (response && response.error) {
          this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
        } else {
          const blob = new Blob([Res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `pago_recolecciones_${inicio}-${fin}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      }
    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div style={{ backgroundColor: 'white' }}>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(PagoTransportista)
